import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControlErrorPipe, FormControlKeyErrorPipe } from '@markant-platform/shared/util-pipes';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MarkantElementsModule, MarkantSelectOption } from '@markant/elements-angular';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { BookingDataForm, BookingWorkflowData } from '../../../booking/model/booking.model';
import { CartridgeBookingService } from '../../../services/cartridge-booking.service';

@Component({
  selector: 'markant-platform-billing-info',
  standalone: true,
  imports: [
    CommonModule,
    FormControlErrorPipe,
    FormControlKeyErrorPipe,
    FormsModule,
    MarkantElementsModule,
    ReactiveFormsModule,
    TranslocoPipe,
  ],
  templateUrl: './billing-info.component.html',
  styleUrl: './billing-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingInfoComponent {
  private translocoService: TranslocoService = inject(TranslocoService);
  private cartridgeBookingService: CartridgeBookingService = inject(CartridgeBookingService);

  @Input({ required: true }) bookingDataForm!: BookingDataForm;
  @Input({ required: true }) bookingData!: BookingWorkflowData;
  @Input() submitted = false;

  languageSelectOptions: MarkantSelectOption[] = (this.translocoService.getAvailableLangs() as string[]).map(
    lang =>
      ({
        value: lang,
        representation: this.translocoService.translate(`languageSelect.${lang}`),
        disabled: false,
      }) as MarkantSelectOption
  );

  get billingEmail(): FormControl<string | null> {
    return this.bookingDataForm.controls.billingEmail;
  }

  get billingLanguageIsoCode(): FormControl<string | null> {
    return this.bookingDataForm.controls.billingLanguageIsoCode;
  }

  sendTrackingData(inputName: string): void {
    const inputTranslatedName = this.translocoService.translate(inputName);
    this.cartridgeBookingService.pushTrackingEventData(
      'Step 01 - Your data',
      this.bookingData,
      `Click Input field - ${inputTranslatedName}`
    );
  }
}
